import styles from "./listing.module.css";
import { ArrowUp } from "react-feather";
import moment from "moment";

const Listing = ({ requestList, setIsModalOpen, setDetails }) => {
  return (<>
    {requestList && requestList?.length === 0 && (<div className={`${styles.NoDataMain}`}>
      <div className={`${styles.NoDataIMG}`}>
        <img src="/static/img/NoRequestIcon.png" alt="No Data" />
      </div>
      <p className={`${styles.NoDataText}`}>All clear!</p>
      <p className={`${styles.NoDataTextSub}`}>You don’t have any request.</p>
    </div>)}

    <div className={`${styles.MaintenanceReqCardRow}`}>
      {requestList && requestList?.length > 0 && requestList?.map((maintenance) => {
        return (<div
          className={`${styles.MaintenanceReqCard}`}
          onClick={() => {
            setDetails(maintenance);
            setIsModalOpen(true);
          }}
          key={maintenance.id}
        >
          <div className={`${styles.CardImgSec} Secondary`}>
            <img src={maintenance?.image} class={`${styles.IMG}`} alt="" />
          </div>
          <div className={`${styles.MainReCardCon}`}>
            <div>
              <p className={`${styles.Title}`}>{maintenance?.title}</p>
              <div className={`${styles.MainReCardIdStatus}`}>
                <p className={styles.MainReID}>
                  {maintenance?.tenant_name}{" "}
                  <span>{maintenance?.apt_name}</span>
                </p>

                {/* Show 'Archived' badge if archived */}
                {maintenance.is_archived === 1 && (<span className={styles.ArchivedBadge}>Archived</span>)}

                {/* Show status if not archived */}
                {maintenance.is_archived !== 1 && (<>
                  {maintenance?.current_status === 0 && (<span className={`${styles.MainReStatus} ${styles.Open}`}>Open</span>)}
                  {maintenance?.current_status === 1 && (<span className={`${styles.MainReStatus} ${styles.InProgress}`}>Assigned</span>)}
                  {maintenance?.current_status === 2 && (<span className={`${styles.MainReStatus} ${styles.InProgress}`}>Scheduled</span>)}
                  {maintenance?.current_status === 3 && (<span className={`${styles.MainReStatus} ${styles.Resolved}`}>Resolved</span>)}
                  {maintenance?.current_status === 4 && (<span className={`${styles.MainReStatus} ${styles.Cancelled}`}>Hold</span>)}
                </>)}
              </div>
              <div className={`${styles.MainReCardIdStatusTwo}`}>
                <p className={`${styles.MainReDate}`}>Submitted {moment(maintenance?.created_at).fromNow()}</p>
                {maintenance?.priority === 1 && (<p className={`${styles.ReffStatus} ${styles.Low}`}>
                  <ArrowUp />
                  <span>Low</span>
                </p>)}

                {maintenance?.priority === 2 && (<p className={`${styles.ReffStatus} ${styles.Medium}`}>
                  <ArrowUp />
                  <span>Medium</span>
                </p>)}

                {maintenance?.priority === 3 && (<p className={`${styles.ReffStatus} ${styles.High}`}>
                  <ArrowUp />
                  <span>High</span>
                </p>)}
              </div>
            </div>
          </div>
        </div>);
      })}
    </div>
  </>);
};

export default Listing;